/**
 * Recursively parses a JSON string until it yields an object or a non-JSON string.
 * This is useful for handling partial double-encoding issues from databases or workflows.
 * 
 * @param {string|object|any} input - The input to parse
 * @returns {object|any} - The parsed object or original input
 */
export const parseOptions = (input) => {
    if (!input) return null;

    // If it's already an object (and not null), return it
    if (typeof input === 'object' && input !== null) {
        return input;
    }

    // If it's a string, try to parse it
    if (typeof input === 'string') {
        try {
            const trimmed = input.trim();
            if ((trimmed.startsWith('{') && trimmed.endsWith('}')) ||
                (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
                (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
                const parsed = JSON.parse(trimmed);

                // Recursively check if the result is also a stringified JSON
                return parseOptions(parsed);
            }
        } catch (e) {
            // If parsing fails, just return the original string
            // console.warn('JSON Parse Warning:', e);
        }
    }

    return input;
};
